import {GET_BOOKS} from '../../constants/UserConstants';
import {GeneralAction} from "../../@types/actions";
import {GroupFilterObject} from "../../@types/response";

export const GetGroupBooksAction = (data: GroupFilterObject): GeneralAction<GroupFilterObject> => ({
    type: GET_BOOKS,
    payload: data
});
